import { useSelector } from "react-redux";
import Modal from "../../../../../../../components/Modal/Modal";
import Button from "../../../../../../../components/Button/Button";
import VerbaFloLogoWithAlertIcon from "../../../../../../../assets/svg/verbaflo-logo-with-alert-icon";
import CloseIcon from "../../../../../../../assets/svg/close-icon";
import { getHelpdeskLabels } from "../../../../../../../utils/constants/mappings";
import { RootState } from "../../../../../../../redux/store";

interface AssigneeRequiredModalProps {
  open: boolean;
  onClose: () => void;
}

const AssigneeRequiredModal = ({ open, onClose }: AssigneeRequiredModalProps) => {
  const region = useSelector((state: RootState) => state?.auth?.client?.region);
  const helpdeskLabels = getHelpdeskLabels(region ?? "UK");

  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      headerClassName="flex items-center justify-end"
      contentClassName="max-h-[90vh] bg-pure-white dark:bg-pure-white-dk"
      bodyClassName="!px-6 !py-[18px] w-[450px]"
      showCloseButton={false}
    >
      <div className="flex flex-col items-center gap-3">
        <div className="flex w-full items-start justify-between gap-2">
          <div className="flex gap-2">
            <VerbaFloLogoWithAlertIcon className="w-6 h-6" />
          </div>
          <span className="text-base font-medium text-heading-text dark:text-heading-text-dk">
            {helpdeskLabels.assigneeRequiredTitle}
          </span>
          <button
            className="w-[15px] h-[15px] ml-auto self-start bg-gray-100 dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110"
            onClick={onClose}
          >
            <CloseIcon className="w-[5.5px] h-[5.5px] text-verba-indigo dark:text-verba-indigo-dk" />
          </button>
        </div>
        <span className="text-md text-data dark:text-data-dk">
          {helpdeskLabels.assigneeRequiredMessage}
        </span>
        <div className="flex justify-end items-center gap-2 w-full mt-3">
          <Button
            innerText="Okay, got it"
            buttonContainerClass="w-[110px] py-[4px] border border-verba-indigo dark:border-verba-indigo-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk rounded-[8px]"
            innerTextClass="text-heading-text dark:text-heading-text-dk text-md font-semibold"
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AssigneeRequiredModal;
